import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=8b0cf7cc&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/error/error-page.scss?vue&type=style&index=0&id=8b0cf7cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0cf7cc",
  null
  
)

export default component.exports